<template>
    <GChart
      type="PieChart"
      :data="chartData"
      :options="options"
      style="width: 100%"
    />
  </template>
  
  <script>
  import { GChart } from 'vue-google-charts'
  
  export default {
    components: {
      GChart
    },
  
    props: {
      breakdown: {
        type: Object,
        default: () => ({})
      }
    },
  
    data() {
      return {
        options: {
          pieHole: 0.4,
          height: 300,
          legend: { position: 'bottom' },
          chartArea: { width: '90%', height: '80%' }
        }
      }
    },
  
    computed: {
      chartData() {
        return [
          ['Type', 'Amount'],
          ['PAYE', Number(this.breakdown?.paye || 0)],
          ['NI', Number(this.breakdown?.ni || 0)],
          ['Pension', Number(this.breakdown?.pension || 0)]
        ]
      }
    }
  }
  </script>